"use client";
import { forwardRef } from "react";
import AppSnackbar from "./AppSnackbar";
import { SnackbarTypeEnum } from "@/models";
import { CustomContentProps } from "notistack";

const AppSnackbarError = forwardRef<
  HTMLDivElement,
  CustomContentProps & { type?: SnackbarTypeEnum }
>(({ type = SnackbarTypeEnum.ErrorServer, ...props }, ref) => {
  return <AppSnackbar {...props} type={type} ref={ref} />;
});

AppSnackbarError.displayName = "AppSnackbarError";
export default AppSnackbarError;
